module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-136 829 9.2 12.5\"><path d=\"M-129.5 830.9c-.5-.4-1.2-.5-2.2-.5h-1.4v5h1.1c1.4 0 2.1-.2 2.7-.7.5-.5.7-1.1.7-1.9 0-.8-.3-1.5-.9-1.9zm-6.5 4.5h1.3V829h3.1c1.5 0 2.5.2 3.2.8.9.6 1.5 1.6 1.5 3 0 1.1-.4 2.1-1.1 2.8-.9.9-1.9 1.3-3.7 1.3h-1.4v1.1h5.6v1.4h-5.6v2.1h-1.7v-2.1h-1.3V838h1.3v-1.1h-1.3v-1.5z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/paid.svg
// module id = 885
// module chunks = 0